import React, { forwardRef } from 'react';
import { StyledText } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const Text = forwardRef(({ tag = 'p', children, id, variant = { type: 'copy', order: '1', style: 'normal' }, className, margin, ...rest }, ref) => (React.createElement(StyledText, { id: id, as: tag, className: className, variant: variant, ref: ref, margin: margin, ...pickDataProps(rest), ...pickA11yProps(rest) }, children)));
Text.displayName = 'Text';
//# sourceMappingURL=index.js.map